import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SystemSettings {
  assessment_time_limit: number;
  require_email_verification: boolean;
  support_email: string;
  max_free_assessments: number;
  maintenance_mode: boolean;
}

const DEFAULT_SETTINGS: SystemSettings = {
  assessment_time_limit: 12,
  require_email_verification: true,
  support_email: "support@example.com",
  max_free_assessments: 1,
  maintenance_mode: false,
};

export const useSystemSettings = () => {
  return useQuery({
    queryKey: ["system-settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("system_settings")
        .select("key, value");

      if (error) {
        console.error("Error fetching system settings:", error);
        return DEFAULT_SETTINGS;
      }

      const settings: Record<string, any> = {};
      
      data?.forEach((setting) => {
        settings[setting.key] = setting.value;
      });

      return { ...DEFAULT_SETTINGS, ...settings } as SystemSettings;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
  });
};
